import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=4c4b8b1c&scoped=true"
import script from "./Interviews.vue?vue&type=script&lang=js"
export * from "./Interviews.vue?vue&type=script&lang=js"
import style0 from "./Interviews.vue?vue&type=style&index=0&id=4c4b8b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b8b1c",
  null
  
)

export default component.exports